import { capitalize, MenuItem, Select } from '@mui/material';
import { type Condition } from '@repo/api-gw-sdk';

import {
  type FilterProperty,
  PropertyPolicyRelation,
} from '@/types/advanceFilter';

import { OPERATORS } from './OperatorSelect';

/**
 * Operator picker at the top of a filter chip's panel, offering the same operators as the condition builder's
 * `OperatorSelect`. It keeps the values the condition already holds, though: every operator consumes the same list
 * of values, and the common edit here is flipping a filter to its negation — which would be pointless if it
 * emptied the selection first.
 */
export const FilterOperatorSelect = ({
  condition,
  property,
  onChange,
}: {
  condition: Condition;
  property: FilterProperty;
  onChange: (condition: Condition) => void;
}) => {
  const relation =
    property.policyRelation ?? PropertyPolicyRelation.MultipleValues;

  return (
    <Select
      fullWidth
      data-testid={`filter-operator-${property.name}`}
      value={condition.operator ?? ''}
      onChange={(event) =>
        onChange({ ...condition, operator: event.target.value })
      }
    >
      {Object.entries(OPERATORS[relation]).map(([operator, { label }]) => (
        <MenuItem key={operator} value={operator}>
          {capitalize(label)}
        </MenuItem>
      ))}
    </Select>
  );
};
